// 韩语
export default {
  Login: {
    Title: "계정에 로그인",
    describe: "로그인하거나 계정을 생성하여 시작하십시오.",
    Google: "Google로 계속하기",
    Apple: "Apple로 계속하기",
    or: "또는",
    Emailplaceholder: "이메일 주소",
    Passwordplaceholder: "비밀번호",
    Login: "로그인",
    forgot: "비밀번호를 잊으셨나요?",
    notAccount: "Fineshare 계정이 없으신가요?",
    Signup: "가입하기",
    InvalidEmail: "잘못된 이메일 형식입니다.",
    InvalidPassword: "비밀번호는 6자 이상이어야 합니다.",
    loading: "로딩 중...",
    login: "로그인",
    errorText: "로그인 실패, 사용자 이름과 비밀번호를 확인하세요.",
  },
  signup: {
    Title: "계정 만들기",
    describe: "몇 초 만에 Fineshare 계정을 만드세요.",
    Google: "Google로 가입하기",
    Apple: "Apple로 가입하기",
    or: "또는",
    Emailplaceholder: "이메일 주소 입력",
    Passwordplaceholder: "6자리 비밀번호 입력",
    Already: "이미 계정이 있나요?",
    Login: "로그인",
    By: "계정을 생성함으로써 저는 다음에 동의한 것으로 간주됩니다",
    Privacy: "개인정보 처리방침",
    Terms: "이용약관",
    and: "그리고",
    signupText: "계정 만들기",
    InvalidEmail: "잘못된 이메일 형식입니다.",
    InvalidPassword: "비밀번호는 6자 이상이어야 합니다.",
    loading: "로딩 중...",
    passwordError: "이 이메일 주소는 이미 등록되었습니다.",
    again: "너무 많은 요청을 하셨습니다. 나중에 다시 시도해 주세요.",
    Registration: "등록 실패, 이메일과 비밀번호를 확인하세요.",
    hasRegistered: "이 이메일 주소는 이미 등록되었습니다.",
    Title2: "Fineshare 계정을 생성하세요",
  },
  Home: {
    Welcome: "Fineshare 계정 센터에 오신 것을 환영합니다",
    Hi: "안녕하세요,",
    Order: "내 주문",
    orders: "우리의 구매 주문 보기",
    Learn: "자세히 알아보기",
    Product: "제품 관리",
    products: "내가 구매한 제품 보기",
    Setting: "계정 설정",
    Settings: "계정 세부 사항 및 비밀번호 변경",
    account: "계정을 최대한 활용하세요",
    FineCam: "FineCam",
    FineCams: "어디서든 영감을 주는 비디오를 만들고 공유하세요",
    FineVoice: "FineVoice",
    FineVoices: "원하는 방식으로 좋아하는 목소리로 보이스오버를 만들어요",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "당신의 목소리를 변환하고 감정을 전달하세요",
    Singify: "Singify",
    Singifys: "원하는 목소리로 AI 커버를 만들어요",
  },
  success: {
    Congratulations: "축하합니다!",
    successfully: "Fineshare 계정이 성공적으로 생성되었습니다.",
  },
  successapp: {
    Successful: "로그인 성공!",
    successfully1:
      "Fineshare 계정에 성공적으로 로그인했습니다. 이제 앱을 사용하기 시작할 수 있습니다.",
    successfully2:
      "Fineshare 계정에 성공적으로 로그인했습니다. 이제 이 창을 닫고 앱을 사용하기 시작할 수 있습니다.",
    Go: "Fineshare 사용자 센터로 가기",
  },
  forgot: {
    ForgotPas: "비밀번호를 잊으셨나요?",
    Enter1: "비밀번호 재설정 이메일을 입력하세요",
    Enter2: "이메일 주소를 입력하시면 비밀번호 재설정 링크를 보내드립니다.",
    exmple: "{email}",
    Back: "로그인으로 돌아가기",
    submitText: "제출",
    errorText: "이메일 주소를 입력해 주세요",
    loading: "로딩 중...",
    sent: "이메일 주소로 이메일을 보냈습니다",
    notExist: "이메일이 존재하지 않습니다. 이메일을 확인해 주세요",
    Reset: "재설정 실패, 이메일을 확인해 주세요",
  },
  account: {
    Settings: "계정 설정",
    Change: "계정 정보, 비밀번호 등을 변경하세요.",
    Personal: "개인 정보",
    email: "이메일:",
    Name: "사용자 이름:",
    Edit: "편집",
    title: "사용자 이름 변경",
    message: "입력한 이름은 비어 있을 수 없습니다.",
    placeholder: "사용자 이름을 입력하세요",
    Reset: "비밀번호 재설정",
    Resets:
      "비밀번호를 재설정할 수 있습니다. 6자 이상의 숫자와 비밀번호를 입력하세요",
    ResetPas: "비밀번호 재설정",
    Delete: "계정 삭제",
    Deletes:
      "이 작업은 계정을 영구히 삭제하고 모든 데이터가 사라집니다. 삭제한 계정은 복구할 수 없습니다.",
    sure: "정말로 Fineshare 계정을 삭제하시겠습니까?",
    sures:
      "계정을 삭제하면 Fineshare에 있는 모든 데이터가 영구히 삭제됩니다. 계정 삭제를 진행하려면 인증 코드를 보내드렸습니다. 코드를 입력하고 확인을 클릭하세요.",
    Deletebtn: "삭제",
    Deleteplaceholder: "6자리 인증 코드를 입력하세요",
  },
  order: {
    Order: "내 주문",
    history: "주문 내역이 이 페이지에 기록됩니다",
    dont: "아직 제품이 없습니다",
    Buy: "지금 구매하여 최적화를 더 얻으세요. 아래 버튼을 클릭하여 지금 바로 구매하세요",
    BuyBtn: "지금 구매",
    OrderId: "주문 ID:",
    Price: "가격:",
    Date: "주문 날짜:",
  },
  Product: {
    Product: "내 제품",
    products: "계정에 로그인된 제품들",
    dont: "아직 제품이 없습니다",
    Management: "디바이스 관리 >",
  },
  redeem: {
    Redeem: "회원권 교환",
    products: "여기에서 Fineshare 제품을 교환할 수 있습니다",
    Please: "교환 코드를 입력하세요",
    placeholder: "교환 코드",
    Submit: "제출",
    Notes: "주의 사항:",
    Notes1: "1.교환 코드 형식: XXXXX;",
    Notes2: "2.교환한 제품을 보려면 '제품' 메뉴를 클릭하세요.",
    Successfully: "교환 성공",
    Follow: "아래 단계를 따라 VoiceTrans 사용을 시작하세요:",
    step1: "1. Fineshare VoiceTrans를 다운로드하고 설치합니다.",
    step2: "2. VoiceTrans를 열고 ",
    Account: "계정",
    step3: "3. 이메일과 비밀번호를 입력하여 Fineshare 계정에 로그인합니다.",
    Tips: "팁: 더 나은 사용을 위해 ",
    guide: "가이드를",
    Redemption: "교환 실패",
    redeemed:
      "이 교환 코드는 이미 사용되었습니다. 소프트웨어를 열고 다시 로그인하여 사용을 시작하세요.",
    Failed: "교환 실패",
    check: "교환 코드를 확인하세요.",
  },
  details: {
    Product: "내 제품",
    products: "구입한 모든 제품은 이 페이지에 있습니다",
    Back: "목록으로 돌아가기",
    Name: "장치 이름",
    system: "장치 시스템",
    status: "장치 상태",
    Operation: "작업",
    Delete: "삭제",
    contact:
      "현재 장치 삭제는 지원되지 않습니다. 장치를 삭제해야 하는 경우, 다음 방법으로 저희에게 연락해주세요：",
  },
  nav: {
    Home: "홈",
    Account: "계정",
    Order: "주문",
    Product: "제품",
    Redeem: "교환",
    Help: "도움말 센터",
  },
  auth: {
    Authorization: "인증 성공!",
    wait: "앱으로 돌아가고 있습니다. 잠시만 기다려 주세요...",
  },
  notfound: {
    Not: "페이지를 찾을 수 없습니다",
    Unfortunately:
      "죄송합니다만, 찾고 계신 페이지는 존재하지 않거나 입력하신 링크에 오류가 있습니다.",
    Home: "홈으로 돌아가기",
  },
  topuser: {
    Settings: "계정 설정",
    language: "언어",
    Logout: "로그아웃",
  },
  loginweb: {
    Conversion: "변환이 곧 시작됩니다",
    currently: "현재 대기 중인 사람은 ",
    people: "명입니다!",
    Please: "로그인해주세요. 변환이 완료되면 결과를 이메일로 보내드립니다.",
    dont: "로그인하고 싶지 않아요",
  },
  mobilelogin: {
    Welcome: "Fineshare에 오신 것을 환영합니다! 시작하려면 로그인 해주세요.",
  },
  reset: {
    Reset: "새로운 비밀번호 재설정",
    Password:
      "비밀번호는 6자 이상이어야 하며, 최소 1개의 문자와 1개의 숫자가 포함되어야 합니다.",
    password: "새 비밀번호를 입력하세요",
    Back: "로그인 화면으로 돌아가기",
    Congratulations: "축하합니다!",
    successfully: "비밀번호 재설정 성공, 즉시 로그인 시작",
    Login: "로그인",
    Please: "6자리 숫자와 문자를 입력하세요",
    failed: "비밀번호 재설정 실패, 이메일에서 재설정 링크를 클릭하세요",
  },
  verification: {
    verification: "인증 코드를 입력하세요",
    haveverification: "인증 코드를 보냈습니다: ",
    Please: "아래에서 받은 인증 코드를 입력하세요:",
    Enter: "6자리 인증 코드를 입력하세요",
    Resend: "인증 코드 재전송",
    Wait: "다시 보내기 전까지 ",
    again: "초 대기해주세요",
    Verify: "확인",
    error: "인증 코드 오류",
    verificationcode: "인증 코드를 입력하세요",
  },
};
